export const neighborhoods = [
  {
    id: 'n1',
    name: 'Sector 4: Neon District',
    status: 'High Activity',
    image: 'https://images.unsplash.com/photo-1555658636-6e4a36210be7?auto=format&fit=crop&q=80&w=800',
    tags: ['Nightlife', 'Tech Hub', 'Street Food'],
    score: 98,
    coords: '40.7128° N, 74.0060° W'
  },
  {
    id: 'n2',
    name: 'The Old Port',
    status: 'Moderate Activity',
    image: 'https://images.unsplash.com/photo-1542435503-956c469947f6?auto=format&fit=crop&q=80&w=800',
    tags: ['Historic', 'Seafood', 'Quiet Walks'],
    score: 85,
    coords: '40.7048° N, 74.0015° W'
  },
  {
    id: 'n3',
    name: 'Cyber Alley Market',
    status: 'Surging',
    image: 'https://images.unsplash.com/photo-1519608487953-e999c86e7455?auto=format&fit=crop&q=80&w=800',
    tags: ['Shopping', 'Gadgets', 'Underground'],
    score: 92,
    coords: '40.7222° N, 73.9980° W'
  }
];

export const liveBoards = [
  { id: 'b1', user: 'System_Watcher', action: 'discovered a hidden speakeasy in', location: 'Sector 4', time: '2m ago', type: 'discovery' },
  { id: 'b2', user: 'Transit_Node', action: 'reports heavy crowds at', location: 'Central Hub', time: '5m ago', type: 'alert' },
  { id: 'b3', user: 'Local_Guide_99', action: 'rated 5 stars for', location: 'Synth Noodle Bar', time: '12m ago', type: 'review' },
  { id: 'b4', user: 'Commuter_X', action: 'added a new route via', location: 'The Old Port', time: '18m ago', type: 'route' },
];

export const savedPlaces = [
  { id: 'p1', name: 'Synth Noodle Bar', category: 'Dining', cost: '$$', rating: 4.8, distance: '0.4km' },
  { id: 'p2', name: 'Aero-Tram Station 04', category: 'Transit', cost: '$', rating: 4.2, distance: '1.2km' },
  { id: 'p3', name: 'Neon District Arcade', category: 'Entertainment', cost: '$$$', rating: 4.9, distance: '0.8km' },
  { id: 'p4', name: 'Underground Data Cafe', category: 'Workspace', cost: '$$', rating: 4.5, distance: '2.1km' },
];

export const recommenders = [
  { id: 'u1', name: 'Alex_V', avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&q=80&w=150', match: '94%' },
  { id: 'u2', name: 'Nova_Star', avatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?auto=format&fit=crop&q=80&w=150', match: '88%' },
  { id: 'u3', name: 'Echo_Location', avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&q=80&w=150', match: '82%' },
];

export const weekendRoutes = [
  { id: 'r1', title: 'Cyberpunk Night Out', stops: 4, duration: '5h', intensity: 'High' },
  { id: 'r2', title: 'Historic Port Walk', stops: 3, duration: '3h', intensity: 'Low' },
  { id: 'r3', title: 'Tech Hub Scavenger Hunt', stops: 6, duration: '4h', intensity: 'Medium' },
];